<div style="max-width: 1900px; max-height: 800px;">
  <img [src]="'data:image/png;base64,' + data?.picture" alt="Image">
</div>
<div style="padding: 20px; display: flex;justify-content: flex-end;" *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
  <button mat-raised-button color="warn" type="button" (click)="onDeletePicture()">
    <mat-icon>delete</mat-icon> {{ 'button.delete' | translate}}
  </button>
</div>